import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { AvatarProfileSizeType } from '../../../../../../components/avatarProfile/types/avatarProfileSizeType';
import { AvatarProfileStateType } from '../../../../../../components/avatarProfile/types/avatarProfileStateType';
import { AvatarProfileVariantType } from '../../../../../../components/avatarProfile/types/avatarProfileVariantType';
import { SelectionIndicatorSizeType, SelectionIndicatorVariantType, } from '../../../../../../components/selectionIndicator/types/selectionIndicator';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../text/variants';
const buildCommonInitialsWithBadgeProps = (FOUNDATIONS) => ({
    rootContainer: {
        display: 'flex',
        flex_direction: 'column',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_150,
    },
    avatarWrapper: {
        position: 'relative',
    },
    avatarContainer: {
        display: 'flex',
        justify_content: 'center',
        align_items: 'center',
        border_radius: FOUNDATIONS.radius_1000,
        background_color: FOUNDATIONS.color_comp_resources_avatarprofile_initials_bg,
        border_style: 'solid',
        border_width: FOUNDATIONS.border_50,
        border_color: FOUNDATIONS.color_comp_resources_avatarprofile_initials_default_border,
        width: '3.5rem',
        height: '3.5rem',
    },
    avatarContent: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        display: 'flex',
        align_items: 'center',
        justify_content: 'center',
        pointer_events: 'none',
    },
    initials: {
        font_variant: TextVariantType.FONT_PARAGRAPH_50,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_resources_avatarprofile_initials_font,
    },
    badgeLogoContainer: {
        position: 'absolute',
        bottom: '-0.25rem',
        right: '-0.25rem',
    },
    badgeIconContainer: {
        position: 'absolute',
        bottom: '-0.25rem',
        right: '-0.25rem',
    },
    labelContainer: {
        width: '4.375rem',
    },
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_500,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_50,
        text_align: 'center',
    },
});
const buildCommonInitialsWithBadgeExtraExtraSmallProps = (FOUNDATIONS, FONT) => {
    const commonInitialsProps = buildCommonInitialsWithBadgeProps(FOUNDATIONS);
    return {
        ...commonInitialsProps,
        avatarContainer: {
            ...commonInitialsProps.avatarContainer,
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
        },
        initials: {
            ...commonInitialsProps.initials,
            font_variant: TextVariantType.FONT_PARAGRAPH_350,
            font_size: FONT.font_paragraph_350[DeviceBreakpointsType.DESKTOP].font_size,
            line_height: FONT.font_paragraph_350[DeviceBreakpointsType.DESKTOP].line_height,
        },
    };
};
const buildCommonInitialsWithBadgeExtraSmallProps = (FOUNDATIONS, FONT) => {
    const commonInitialsProps = buildCommonInitialsWithBadgeProps(FOUNDATIONS);
    return {
        ...commonInitialsProps,
        avatarContainer: {
            ...commonInitialsProps.avatarContainer,
            width: FOUNDATIONS.size_400,
            height: FOUNDATIONS.size_400,
        },
        initials: {
            ...commonInitialsProps.initials,
            font_variant: TextVariantType.FONT_PARAGRAPH_50,
            font_size: FONT.font_paragraph_50[DeviceBreakpointsType.DESKTOP].font_size,
            line_height: FONT.font_paragraph_50[DeviceBreakpointsType.DESKTOP].line_height,
        },
    };
};
const buildCommonInitialsWithBadgeSmallProps = (FOUNDATIONS) => {
    const commonInitialsProps = buildCommonInitialsWithBadgeProps(FOUNDATIONS);
    return {
        ...commonInitialsProps,
        avatarContainer: {
            ...commonInitialsProps.avatarContainer,
            width: '3rem',
            height: '3rem',
        },
        initials: {
            ...commonInitialsProps.initials,
            font_size: '1.5rem',
            line_height: '2rem',
        },
    };
};
const buildCommonInitialsWithBadgeMediumProps = (FOUNDATIONS) => {
    const commonInitialsProps = buildCommonInitialsWithBadgeProps(FOUNDATIONS);
    return {
        ...commonInitialsProps,
        avatarContainer: {
            ...commonInitialsProps.avatarContainer,
            width: '3.5rem',
            height: '3.5rem',
        },
        initials: {
            ...commonInitialsProps.initials,
            font_size: '1.5rem',
            line_height: '2rem',
        },
    };
};
const buildCommonInitialsWithBadgeLargeProps = (FOUNDATIONS) => {
    const commonInitialsProps = buildCommonInitialsWithBadgeProps(FOUNDATIONS);
    return {
        ...commonInitialsProps,
        avatarContainer: {
            ...commonInitialsProps.avatarContainer,
            width: '4rem',
            height: '4rem',
        },
        initials: {
            ...commonInitialsProps.initials,
            font_size: '1.75rem',
            line_height: '2rem',
        },
    };
};
const buildCommonInitialsWithBadgeExtraExtraLargeProps = (FOUNDATIONS, FONT) => {
    const commonInitialsProps = buildCommonInitialsWithBadgeProps(FOUNDATIONS);
    return {
        ...commonInitialsProps,
        avatarContainer: {
            ...commonInitialsProps.avatarContainer,
            width: FOUNDATIONS.size_1089,
            height: FOUNDATIONS.size_1089,
        },
        initials: {
            ...commonInitialsProps.initials,
            font_variant: TextVariantType.FONT_HEADING_6,
            font_size: FOUNDATIONS.font_size_heading_xllm_display_xl,
            line_height: FOUNDATIONS.font_line_height_heading_xllm_display_xl,
        },
    };
};
export const getInitialsWithBadgeStyles = (FOUNDATIONS, FONT) => {
    const commonInitialsExtraExtraSmallProps = buildCommonInitialsWithBadgeExtraExtraSmallProps(FOUNDATIONS, FONT);
    const commonInitialsExtraSmallProps = buildCommonInitialsWithBadgeExtraSmallProps(FOUNDATIONS, FONT);
    const commonInitialsSmallProps = buildCommonInitialsWithBadgeSmallProps(FOUNDATIONS);
    const commonInitialsMediumProps = buildCommonInitialsWithBadgeMediumProps(FOUNDATIONS);
    const commonInitialsLargeProps = buildCommonInitialsWithBadgeLargeProps(FOUNDATIONS);
    const commonInitialsExtraExtraLargeProps = buildCommonInitialsWithBadgeExtraExtraLargeProps(FOUNDATIONS, FONT);
    return {
        [AvatarProfileVariantType.INITIALS_WITH_BADGE]: {
            [AvatarProfileSizeType.EXTRA_EXTRA_SMALL]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonInitialsExtraExtraSmallProps,
                },
                [AvatarProfileStateType.SELECTED]: {
                    ...commonInitialsExtraExtraSmallProps,
                    avatarContainer: {
                        ...commonInitialsExtraExtraSmallProps.avatarContainer,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                    },
                    initials: {
                        ...commonInitialsExtraExtraSmallProps.initials,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.EXTRA_SMALL,
                    },
                },
                [AvatarProfileStateType.DISABLED]: {
                    ...commonInitialsExtraExtraSmallProps,
                    avatarContainer: {
                        ...commonInitialsExtraExtraSmallProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    initials: {
                        ...commonInitialsExtraExtraSmallProps.initials,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    label: {
                        ...commonInitialsExtraExtraSmallProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
                [AvatarProfileStateType.DISABLED_SELECTED]: {
                    ...commonInitialsExtraExtraSmallProps,
                    avatarContainer: {
                        ...commonInitialsExtraExtraSmallProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_50,
                        cursor: 'auto',
                    },
                    initials: {
                        ...commonInitialsExtraExtraSmallProps.initials,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.EXTRA_SMALL,
                    },
                    label: {
                        ...commonInitialsExtraExtraSmallProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                },
            },
            [AvatarProfileSizeType.EXTRA_SMALL]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonInitialsExtraSmallProps,
                },
                [AvatarProfileStateType.SELECTED]: {
                    ...commonInitialsExtraSmallProps,
                    avatarContainer: {
                        ...commonInitialsExtraSmallProps.avatarContainer,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                    },
                    initials: {
                        ...commonInitialsExtraSmallProps.initials,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.EXTRA_SMALL,
                    },
                },
                [AvatarProfileStateType.DISABLED]: {
                    ...commonInitialsExtraSmallProps,
                    avatarContainer: {
                        ...commonInitialsExtraSmallProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    initials: {
                        ...commonInitialsExtraSmallProps.initials,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    label: {
                        ...commonInitialsExtraSmallProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
                [AvatarProfileStateType.DISABLED_SELECTED]: {
                    ...commonInitialsExtraSmallProps,
                    avatarContainer: {
                        ...commonInitialsExtraSmallProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_50,
                        cursor: 'auto',
                    },
                    initials: {
                        ...commonInitialsExtraSmallProps.initials,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.EXTRA_SMALL,
                    },
                    label: {
                        ...commonInitialsExtraSmallProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                },
            },
            [AvatarProfileSizeType.SMALL]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonInitialsSmallProps,
                },
                [AvatarProfileStateType.SELECTED]: {
                    ...commonInitialsSmallProps,
                    avatarContainer: {
                        ...commonInitialsSmallProps.avatarContainer,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                    },
                    initials: {
                        ...commonInitialsSmallProps.initials,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.EXTRA_SMALL,
                    },
                },
                [AvatarProfileStateType.DISABLED]: {
                    ...commonInitialsSmallProps,
                    avatarContainer: {
                        ...commonInitialsSmallProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    initials: {
                        ...commonInitialsSmallProps.initials,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    label: {
                        ...commonInitialsSmallProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
                [AvatarProfileStateType.DISABLED_SELECTED]: {
                    ...commonInitialsSmallProps,
                    avatarContainer: {
                        ...commonInitialsSmallProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_50,
                        cursor: 'auto',
                    },
                    initials: {
                        ...commonInitialsSmallProps.initials,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.EXTRA_SMALL,
                    },
                    label: {
                        ...commonInitialsSmallProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                },
            },
            [AvatarProfileSizeType.MEDIUM]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonInitialsMediumProps,
                },
                [AvatarProfileStateType.SELECTED]: {
                    ...commonInitialsMediumProps,
                    avatarContainer: {
                        ...commonInitialsMediumProps.avatarContainer,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                    },
                    initials: {
                        ...commonInitialsMediumProps.initials,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.SMALL,
                    },
                },
                [AvatarProfileStateType.DISABLED]: {
                    ...commonInitialsMediumProps,
                    avatarContainer: {
                        ...commonInitialsMediumProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    initials: {
                        ...commonInitialsMediumProps.initials,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    label: {
                        ...commonInitialsMediumProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
                [AvatarProfileStateType.DISABLED_SELECTED]: {
                    ...commonInitialsMediumProps,
                    avatarContainer: {
                        ...commonInitialsMediumProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_50,
                        cursor: 'auto',
                    },
                    initials: {
                        ...commonInitialsMediumProps.initials,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.SMALL,
                    },
                    label: {
                        ...commonInitialsMediumProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                },
            },
            [AvatarProfileSizeType.LARGE]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonInitialsLargeProps,
                },
                [AvatarProfileStateType.SELECTED]: {
                    ...commonInitialsLargeProps,
                    avatarContainer: {
                        ...commonInitialsLargeProps.avatarContainer,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                    },
                    initials: {
                        ...commonInitialsLargeProps.initials,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.SMALL,
                    },
                },
                [AvatarProfileStateType.DISABLED]: {
                    ...commonInitialsLargeProps,
                    avatarContainer: {
                        ...commonInitialsLargeProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    initials: {
                        ...commonInitialsLargeProps.initials,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    label: {
                        ...commonInitialsLargeProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
                [AvatarProfileStateType.DISABLED_SELECTED]: {
                    ...commonInitialsLargeProps,
                    avatarContainer: {
                        ...commonInitialsLargeProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_50,
                        cursor: 'auto',
                    },
                    initials: {
                        ...commonInitialsLargeProps.initials,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.SMALL,
                    },
                    label: {
                        ...commonInitialsLargeProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                },
            },
            [AvatarProfileSizeType.EXTRA_EXTRA_LARGE]: {
                [AvatarProfileStateType.DEFAULT]: {
                    ...commonInitialsExtraExtraLargeProps,
                },
                [AvatarProfileStateType.SELECTED]: {
                    ...commonInitialsExtraExtraLargeProps,
                    avatarContainer: {
                        ...commonInitialsExtraExtraLargeProps.avatarContainer,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                    },
                    initials: {
                        ...commonInitialsExtraExtraLargeProps.initials,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.SMALL,
                    },
                },
                [AvatarProfileStateType.DISABLED]: {
                    ...commonInitialsExtraExtraLargeProps,
                    avatarContainer: {
                        ...commonInitialsExtraExtraLargeProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'auto',
                    },
                    initials: {
                        ...commonInitialsExtraExtraLargeProps.initials,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    label: {
                        ...commonInitialsExtraExtraLargeProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
                [AvatarProfileStateType.DISABLED_SELECTED]: {
                    ...commonInitialsExtraExtraLargeProps,
                    avatarContainer: {
                        ...commonInitialsExtraExtraLargeProps.avatarContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_accent_disabled_border_50,
                        cursor: 'auto',
                    },
                    initials: {
                        ...commonInitialsExtraExtraLargeProps.initials,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                    selectionIndicator: {
                        variant: SelectionIndicatorVariantType.DEFAULT,
                        size: SelectionIndicatorSizeType.SMALL,
                    },
                    label: {
                        ...commonInitialsExtraExtraLargeProps.label,
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=initialsWithBadge.js.map